import loaderImg from '@assets/loader_200_trasp.gif'

const LoaderMini = () => {
	return (
		<div className='mt-1 flex items-center gap-2'>
			<img src={loaderImg} alt='loader' className='w-5 h-5 animate-spin' />
			<span className='text-[12px]'>Attendi qualche secondo...</span>
		</div>
	)
}

export default LoaderMini
